import {actions} from '../actions';

const initialState = {};

export default function servicesReducer(state = initialState, action) {
  switch (action.type) {
    case actions.TAXONOMY.FETCH_FULFILLED: {
      return (action.payload || []).reduce(serviceReducer, {});
    }
  }

  return state;
}

function serviceReducer(services, taxonomyNode) {
  const {service, children} = taxonomyNode;
  const childServices = (children || []).length
    ? children.reduce(serviceReducer, {})
    : {};

  return {
    ...services,
    ...childServices,
    [service.handle]: {
      ...service,
      children: (children || []).map(child => child.service.handle),
    },
  };
}
